import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { H2 } from 'components/core/Typography';
import { Section, Container } from 'components/core/Page';
import { Image } from 'components/core/Image';
import { Cities } from 'components/molecules';
import { stateWiseCities } from 'pages/StyleGuidePage/PSPCities';
import { StorageNearYouData } from './StorageData';
import { getNearbyCities } from 'store/selectors/getNearbyFacilities';
import './StorageNearYou.scss';

const EMPTY_GEO = {};

export function StorageNearYou({
	geolocation: geolocationProp,
	nearbyCities: nearbyCitiesProp,
	type = '',
}) {
	const storeGeolocation = useSelector(
		(state) => state.user?.geolocation || EMPTY_GEO,
	);
	const storeNearbyCities = useSelector(getNearbyCities);
	const geolocation = geolocationProp ?? storeGeolocation;
	const nearbyCities = nearbyCitiesProp ?? storeNearbyCities;
	const filterCitiesByState = geolocation?.region
		? stateWiseCities.find(
				(stateInfo) =>
					stateInfo.abbreviation === geolocation.region ||
					stateInfo.state === geolocation.region,
			)
		: null;
	const { title, image, citiesByState, statesLink, nearByDetectedCities } =
		StorageNearYouData(type, filterCitiesByState?.state, geolocation?.city);

	const citiesByStateData = filterCitiesByState
		? {
				...citiesByState,
				cities: filterCitiesByState.cities.slice(0, 7).map((city) => {
					const formattedCity = filterCitiesByState?.abbreviation
						? `${city.name}, ${filterCitiesByState.abbreviation}`
						: city.name;
					return { ...city, name: formattedCity };
				}),
			}
		: null;

	const statesLinkData = {
		...statesLink,
		cities: statesLink.cities.slice(0, 7),
	};

	// Create nearby cities data from state, trimmed to 7 cities
	const nearbyCitiesData =
		nearbyCities && nearbyCities.length > 0
			? {
					title: nearByDetectedCities.title,
					cities: nearbyCities.slice(0, 7).map((city) => ({
						name: city.city + ', ' + city.state,
						slug: city.uri?.startsWith('/')
							? city.uri
							: '/' + city.uri,
					})),
				}
			: null;

	return (
		<Section className="storage-near-you">
			<Container>
				<Image
					src={image}
					alt="featured-cities-icon"
				/>
				<H2
					size="large"
					className="featured-cities-headline"
					weight="extraBold"
				>
					{title}
				</H2>
				<div className="storage-near-you-content">
					{nearbyCitiesData && <Cities {...nearbyCitiesData} />}
					{citiesByStateData && <Cities {...citiesByStateData} />}
					{statesLinkData && <Cities {...statesLinkData} />}
				</div>
			</Container>
		</Section>
	);
}

StorageNearYou.propTypes = {
	geolocation: PropTypes.object,
	nearbyCities: PropTypes.array,
	type: PropTypes.string,
};

export default StorageNearYou;
